import { WarningIcon } from '@/assets/icons';
import {
	APPLICANT_MAPPING_OPTION_SELECT,
	APPLICANT_OPTION_SELECT_ALL,
	FRANCHISE_MAPPING_OPTION_SELECT,
	PROGRAM_OPTION_SELECT_ALL,
} from '@/constant';
import { ForwardedRef, forwardRef, memo } from 'react';

import Checkbox from '../common/checkbox';
import { TFilterWithViewAllRef } from '../common/filter-with-view-all/type';
import Tooltip from '../common/tooltip';
import Select from '../form/select';
import { getShowConfigs } from './helper';
import useLogic from './logic';
import { TSelectDocumentInfoProps } from './type';

const SelectDocumentInfo = (
	props: TSelectDocumentInfoProps,
	ref: ForwardedRef<TFilterWithViewAllRef>
) => {
	const {
		pageType,
		showActionsTop,
		showApplicant,
		showCheckbox,
		showIssuanceApplication,
		optionsApplicant,
		isDocumentArea,
		showProgram,
	} = props;
	const {
		isViewAll,
		document,
		issuanceApplication,
		issuanceApplicationOptions,
		documentOptions,
		applicantId,
		franchiseId,
		applicantMappingOptions,
		franchiseMappingOptions,
		programId,
		programOptions,
		toggleViewAll,
		handleIssuanceApplicationChange,
		handleDocumentChange,
		handleChangeApplicant,
		handleChangeFranchise,
		handleChangeProgram,
	} = useLogic(props, ref);

	const { isShowApplicantMappings, isShowFranchiseMappings } =
		getShowConfigs(pageType);

	return (
		<>
			{showActionsTop && (
				<div className="flex flex-wrap gap-2">
					{showCheckbox && (
						<Checkbox
							checked={isViewAll}
							onChange={toggleViewAll}
							suffixLabel="전체보기"
							id="isViewAll"
						/>
					)}

					{showProgram && (
						<>
							<Tooltip
								title="프로그램 선택은 서류 조회를 위한 필터 기능으로, 서류 작성 및 등록 시 프로그램과 직접적으로 연관되지 않습니다."
								destroyTooltipOnHide
								className="ml-1 py-1.5"
							>
								<div className="cursor-pointer">
									<WarningIcon />
								</div>
							</Tooltip>
							<Select
								options={[PROGRAM_OPTION_SELECT_ALL, ...(programOptions || [])]}
								className="!w-[180px]"
								containerClassName="max-w-max"
								value={programId}
								onChange={handleChangeProgram}
							/>
						</>
					)}

					{isDocumentArea && (
						<>
							{isShowApplicantMappings && (
								<Select
									options={[
										APPLICANT_MAPPING_OPTION_SELECT,
										...(applicantMappingOptions || []),
									]}
									className="!w-[200px]"
									containerClassName="max-w-max"
									value={applicantId}
									onChange={handleChangeApplicant}
								/>
							)}

							{showApplicant && (
								<Select
									options={[
										APPLICANT_OPTION_SELECT_ALL,
										...(optionsApplicant || []),
									]}
									className="!w-[180px]"
									containerClassName="max-w-max"
									value={applicantId}
									onChange={handleChangeApplicant}
									defaultValue=""
								/>
							)}

							{isShowFranchiseMappings && (
								<Select
									options={[
										FRANCHISE_MAPPING_OPTION_SELECT,
										...(franchiseMappingOptions || []),
									]}
									className="!w-[200px]"
									containerClassName="max-w-max"
									value={franchiseId}
									onChange={handleChangeFranchise}
								/>
							)}
						</>
					)}

					{showIssuanceApplication && (
						<Select
							options={issuanceApplicationOptions}
							className="!w-[180px]"
							containerClassName="max-w-max"
							value={issuanceApplication}
							onChange={handleIssuanceApplicationChange}
							showSearch
						/>
					)}

					<Select
						options={documentOptions}
						className="!w-[250px]"
						containerClassName="max-w-max"
						value={document}
						onChange={handleDocumentChange}
						showSearch
					/>

					{!isDocumentArea && (
						<>
							{isShowApplicantMappings && (
								<Select
									options={[
										APPLICANT_MAPPING_OPTION_SELECT,
										...(applicantMappingOptions || []),
									]}
									className="!w-[200px]"
									containerClassName="max-w-max"
									value={applicantId}
									onChange={handleChangeApplicant}
								/>
							)}

							{showApplicant && (
								<Select
									options={[
										APPLICANT_OPTION_SELECT_ALL,
										...(optionsApplicant || []),
									]}
									className="!w-[180px]"
									containerClassName="max-w-max"
									value={applicantId}
									onChange={handleChangeApplicant}
									defaultValue=""
								/>
							)}

							{isShowFranchiseMappings && (
								<Select
									options={[
										FRANCHISE_MAPPING_OPTION_SELECT,
										...(franchiseMappingOptions || []),
									]}
									className="!w-[200px]"
									containerClassName="max-w-max"
									value={franchiseId}
									onChange={handleChangeFranchise}
								/>
							)}
						</>
					)}
				</div>
			)}
		</>
	);
};

export default memo(forwardRef(SelectDocumentInfo));
